import { db } from '../db';
import { BusinessPropertyService } from './business-property-service';
import { BusinessService } from './business-service';
import { CategoryService } from './category-service';
import { DiscountService } from './discount-service';
import { DocketService } from './docket-service';
import { ItemService } from './item-service';
import { MeasurementUnitService } from './measurement-unit-service';
import { MixpanelService } from './mixpanel-service';
import { ModifierService } from './modifier-service';
import { PaymentMethodService } from './payment-method-service';
import { PaymentRestrictionService } from './payment-restriction-service';
import { PricingGroupService } from './pricing-group-service';
import { PrinterService } from './printer-service';
import { RegisterConfigurationService } from './register-configuration-service';
import { RemoteCartService } from './remote-cart-service';
import { RemoteCartServiceV2 } from './remote-cart-service-v2';
import { StaffService } from './staff-service';
import { SubscriptionService } from './subscription-service';
import { TaxService } from './tax-service';
import { TerminalService } from './terminal-service';
import { UnsyncedSaleService } from './unsynced-sale-service';

export const staffService = new StaffService(db);
export const taxService = new TaxService(db);
export const paymentMethodService = new PaymentMethodService(db);

export const itemService = new ItemService(db);
export const categoryService = new CategoryService(db);
export const measurementUnitService = new MeasurementUnitService(db);
export const pricingGroupService = new PricingGroupService(db);

export const businessService = new BusinessService();
export const businessPropertyService = new BusinessPropertyService();
export const registerConfigurationService = new RegisterConfigurationService();
export const subscriptionService = new SubscriptionService();

export const discountService = new DiscountService(db);

export const savedCartService = new RemoteCartService(db);
export const remoteCartServiceV2 = new RemoteCartServiceV2(db);
export const unsyncedSaleService = new UnsyncedSaleService(db);

export const terminalService = new TerminalService(db);
export const printerService = new PrinterService(db);

export const mixpanelService = new MixpanelService(db);
export const paymentRestrictionService = new PaymentRestrictionService(db);
export const docketService = new DocketService(db);
export const modifierService = new ModifierService(db);

export { compressAuditLogs } from './compress-audit-logs';
export { csrfTokenManager } from './csrf-service';
export { PrintAgentService, printAgentService } from './print-agent-service';
export { SearchService, searchService } from './search-service';

export type {
    PrintAgentAlign,
    PrintAgentColumn,
    PrintAgentLine,
    PrinterOptions,
} from './print-agent-service';
